import { StoreLista } from './Lista'

export default new StoreLista({
  nombre: '',
  cue: ''
});


// WEBPACK FOOTER //
// ./src/stores/listados/Instituciones.js